/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';
import CampaignModel from 'cio/models/campaign';
import { action } from '@ember/object';
import CampaignSubscriptionsService from 'cio/services/campaign-subscriptions';
import AccountService from 'cio/services/account';
import ApiErrorsService from 'cio/services/api-errors';
import MasqService from 'cio/services/masq';

interface CampaignFollowButtonSignature {
  Args: {
    campaign: CampaignModel;
    unfollowFromQueryParam?: boolean;
  };
  Element: HTMLButtonElement;
}

export default class CampaignFollowButton extends Component<CampaignFollowButtonSignature> {
  @service account!: AccountService;
  @service apiErrors!: ApiErrorsService;
  @service analytics!: AnalyticsService;
  @service masq!: MasqService;
  @service campaignSubscriptions!: CampaignSubscriptionsService;

  constructor(owner: unknown, args: CampaignFollowButtonSignature['Args']) {
    super(owner, args);

    if (this.args.unfollowFromQueryParam === true && this.isFollowing) {
      this.unfollow();
    }
  }

  get isDisabled() {
    return this.masq.readOnly || this.isLoading;
  }

  get isLoading() {
    return (
      this.campaignSubscriptions.getSubscriptions.isRunning ||
      this.campaignSubscriptions.subscribe.isRunning ||
      this.campaignSubscriptions.unsubscribe.isRunning
    );
  }

  get isFollowing() {
    return this.campaignSubscriptions.subscribedCampaigns.includes(parseInt(this.args.campaign.id));
  }

  @action
  async follow() {
    try {
      await (this.campaignSubscriptions.subscribe as any).perform(this.args.campaign);

      this.analytics.track('campaign', 'follow_campaign_toggled', {
        model: this.args.campaign,
        follow: true,
      });
    } catch (e) {
      this.apiErrors.report(e);
    }
  }

  @action
  async unfollow() {
    try {
      await (this.campaignSubscriptions.unsubscribe as any).perform(this.args.campaign);

      this.analytics.track('campaign', 'follow_campaign_toggled', {
        model: this.args.campaign,
        follow: false,
      });
    } catch (e) {
      this.apiErrors.report(e);
    }
  }
}
